__turbopack_context__.v({
  "button": "stylizedButtonLink-module-scss-module__mX0djG__button",
  "cancel": "stylizedButtonLink-module-scss-module__mX0djG__cancel",
  "disabled": "stylizedButtonLink-module-scss-module__mX0djG__disabled",
  "large": "stylizedButtonLink-module-scss-module__mX0djG__large",
  "link": "stylizedButtonLink-module-scss-module__mX0djG__link",
  "medium": "stylizedButtonLink-module-scss-module__mX0djG__medium",
  "mini": "stylizedButtonLink-module-scss-module__mX0djG__mini",
  "neon-pill": "stylizedButtonLink-module-scss-module__mX0djG__neon-pill",
  "neutral": "stylizedButtonLink-module-scss-module__mX0djG__neutral",
  "primary": "stylizedButtonLink-module-scss-module__mX0djG__primary",
  "secondary": "stylizedButtonLink-module-scss-module__mX0djG__secondary",
  "small": "stylizedButtonLink-module-scss-module__mX0djG__small",
  "tertiary": "stylizedButtonLink-module-scss-module__mX0djG__tertiary",
  "textonly": "stylizedButtonLink-module-scss-module__mX0djG__textonly",
  "wide": "stylizedButtonLink-module-scss-module__mX0djG__wide",
});
